import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

import _ from "lodash";
import {
  CRUDLayout,
  Alert,
  DataStatus,
  InputSearch,
  FilterButton,
} from "components";

import { LaporanAkutansiManajemenApi } from "api";
import { ModalFilter } from "./Section";
import { TabSection } from "./Section";
import Axios from "axios";
import { ExportButton } from "./Comp";
import FileSaver from "file-saver";

export const LaporanAkutansiManajemen = ({ setNavbarTitle }) => {
  const location = useLocation();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dataSalesOrder, setDataSalesOrder] = useState([]);
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [dataFilter, setDataFilter] = useState({
    filter: {
      active: location?.state?.surat_jalan?.filter?.active,
      tgl_sales_order_mulai:
        location?.state?.surat_jalan?.filter?.tgl_sales_order_mulai,
      tgl_sales_order_selesai:
        location?.state?.surat_jalan?.filter?.tgl_sales_order_selesai,
      id_customer: location?.state?.surat_jalan?.filter?.id_customer,
      id_proyek: location?.state?.surat_jalan?.filter?.id_proyek,
      id_karyawan: location?.state?.surat_jalan?.filter?.id_karyawan,
      id_gudang: location?.state?.surat_jalan?.filter?.id_gudang,
      is_opname: location?.state?.surat_jalan?.filter?.is_opname,
    },
    pagination: {
      page: location?.state?.surat_jalan?.filter?.page ?? "1",
      dataLength: location?.state?.surat_jalan?.filter?.dataLength ?? "10",
      totalPage: location?.state?.surat_jalan?.filter?.totalPage ?? "1",
      dataCount: location?.state?.surat_jalan?.filter?.dataCount ?? "0",
    },
  });
  const [dropdownFilter, setDropdownFilter] = useState({
    customer: [],
    proyek: [],
    sales: [],
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });
  const [loadingExport, setLoadingExport] = useState(false);

  const getInitialData = () => {
    setIsPageLoading(true);

    LaporanAkutansiManajemenApi.getPage({
      q: searchConfig.key,
      page: dataFilter?.pagination?.page,
      per_page: dataFilter?.pagination?.dataLength,
      tgl_sales_order_mulai: dataFilter?.filter?.tgl_sales_order_mulai,
      tgl_sales_order_selesai: dataFilter?.filter?.tgl_sales_order_selesai,
      id_customer: dataFilter?.filter?.id_customer,
      id_proyek: dataFilter?.filter?.id_proyek,
      id_karyawan: dataFilter?.filter?.id_karyawan,
    })
      .then((data) => {
        setDataSalesOrder(data?.data?.data ?? []);
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            dataCount: data?.data?.data_count,
            totalPage: data?.data?.total_page,
          },
        });
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        });
      })
      .finally(() => setIsPageLoading(false));
  };

  const getDataDropdown = () => {
    Axios.all([
      LaporanAkutansiManajemenApi.getDropdown("customer"),
      LaporanAkutansiManajemenApi.getDropdown("proyek"),
      LaporanAkutansiManajemenApi.getDropdown("sales"),
    ])
      .then(
        Axios.spread((cuss, pro, kar) => {
          const mappingCustomer = (data) =>
            data.map((val) => ({
              label: val.nama_customer,
              value: val.id_customer,
            }));

          const mappingProyek = (data) =>
            data.map((val) => ({
              label: val.nama_proyek,
              value: val.id_proyek,
            }));

          const mappingKaryawan = (data) =>
            data.map((val) => ({
              label: val.nama_karyawan,
              value: val.id_karyawan,
            }));

          setDropdownFilter({
            customer: [
              { label: "Semua", value: undefined },
              ...mappingCustomer(cuss?.data?.data ?? []),
            ],
            proyek: [
              { label: "Semua", value: undefined },
              ...mappingProyek(pro?.data?.data ?? []),
            ],
            sales: [
              { label: "Semua", value: undefined },
              ...mappingKaryawan(kar?.data?.data ?? []),
            ],
          });
        })
      )
      .finally(() => {});
  };

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  const onInputSearchChange = (e) => {
    const key = e.target.value;

    setSearchConfig({
      ...searchConfig,
      key: e.target.value,
    });
    setDataFilter({
      ...dataFilter,
      pagination: {
        ...dataFilter.pagination,
        page: "1",
        dataLength: "10",
        totalPage: "1",
        dataCount: "0",
      },
    });
    setAlertConfig({
      show: key ? true : false,
      variant: "primary",
      text: "Hasil dari pencarian: " + key,
    });
  };

  const exportData = (tipe) => {
    setLoadingExport(true);

    LaporanAkutansiManajemenApi.export({
      page: dataFilter?.pagination?.page,
      per_page: dataFilter?.pagination?.dataLength,
      tgl_sales_order_mulai: dataFilter?.filter?.tgl_sales_order_mulai,
      tgl_sales_order_selesai: dataFilter?.filter?.tgl_sales_order_selesai,
      id_customer: dataFilter?.filter?.id_customer,
      id_proyek: dataFilter?.filter?.id_proyek,
      id_karyawan: dataFilter?.filter?.id_karyawan,
      active: undefined,
      tipe,
    })
      .then((res) => {
        const data = res.data.data;
        // const urlFile = process.env.REACT_APP_EXPORT_BASE_URL + data;
        FileSaver.saveAs(data, data);
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Export Data gagal",
        });
      })
      .finally(() => setLoadingExport(false));
  };

  useEffect(() => {
    setNavbarTitle("Laporan Kumulatif Produksi");
    getInitialData();

    checkAlert();

    return () => {
      setIsPageLoading(false);
    };
  }, [
    searchConfig.key,
    dataFilter?.pagination?.page,
    dataFilter?.pagination?.dataLength,
    dataFilter?.filter?.active,
    dataFilter?.filter?.tgl_sales_order_mulai,
    dataFilter?.filter?.tgl_sales_order_selesai,
    dataFilter?.filter?.id_customer,
    dataFilter?.filter?.id_proyek,
    dataFilter?.filter?.id_karyawan,
  ]);

  useEffect(() => {
    getDataDropdown();

    return () => {};
  }, []);

  return (
    <CRUDLayout>
      {/* Head Section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              value={searchConfig.key}
              onChange={onInputSearchChange}
            />
            <FilterButton
              active={dataFilter?.filter?.active}
              onClick={() => setShowModalFilter(true)}
              className="mr-2"
            />

            <ExportButton
              loading={loadingExport}
              disabled={!dataFilter?.filter?.active}
            >
              <Dropdown.Item onClick={() => exportData("excel")}>
                Excel (.xlsx)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => exportData("pdf")}>
                PDF (.pdf)
              </Dropdown.Item>
            </ExportButton>
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection></CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* Content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : (
        <TabSection data={dataSalesOrder} />
      )}
      {showModalFilter && (
        <ModalFilter
          show={showModalFilter}
          setShow={setShowModalFilter}
          data={dataFilter}
          setData={setDataFilter}
          dropdown={dropdownFilter}
        />
      )}
    </CRUDLayout>
  );
};
